export default {"src":"/_next/static/media/AIIcon.47c10fee.svg","height":70,"width":130};